import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/district-templates/{id}/document-configs/{configId}']['DELETE'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

/** Soft-deletes a document config from a district template. */
const deleteDistrictDocumentConfig = async ({ id, configId }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/district-templates/{id}/document-configs/{configId}', { id, configId });
  const response = await noodleApiClient.delete(path);
  return response.data;
};

export default deleteDistrictDocumentConfig;
